module.exports = __webpack_public_path__ + "img/2005 (1).50bc71cc.jpg";